var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"fabric-span",style:(`background-color: ${_vm.hexa}`)}),_vm._v("\n    "+_vm._s(_vm.code || _vm.color)+"\n    "),(_vm.code && _vm.color)?_c('small',{staticClass:"text-secondary"},[_vm._v(" ("+_vm._s(_vm.color)+") ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }